/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { accountSchema } from './account-schema';
import { candidateOpportunitySchema } from './candidate-opportunity-schema';
import { candidatesOpportunitiesStatusHistorySchema } from './candidates-opportunities-status-history-schema';
import { clientRequestSchema } from './client-request-schema';
import { contactSchema } from './contact-schema';
import { contactsOpportunitySchema } from './contacts-opportunity-schema';
import { digitalIntakeDetailSchema } from './digital-intake-detail-schema';
import { eventSchema } from './event-schema';
import { opportunityCollaboratorSchema } from './opportunity-collaborator-schema';
import { opportunityLanguageSchema } from './opportunity-language-schema';
import { positionSchema } from './position-schema';
import { userSchema } from './user-schema';
import { ClientBudgetConfirmed, CountryCode, FocusArea, FulfillmentStatus, LaptopProvider, OpportunityStage, OpportunityStageCode, OpportunityTransactionSubType, PracticeAreaEnum, WorkLocation, YesNoMaybe } from "../enums";
export const opportunitySchema: z.AnyZodObject = z.object({
  account: z.lazy(() => accountSchema).nullish(),
  accountId: z.string().uuid().nullish(),
  accountName: z.string().nullish(),
  accountSalesforceId: z.string().nullish(),
  addressCity: z.string().nullish(),
  addressCountryCode: z.string().nullish(),
  addressState: z.string().nullish(),
  addressStreet: z.string().nullish(),
  addressZip: z.string().nullish(),
  allowInterest: z.boolean().nullish(),
  amount: z.number().nullish(),
  billingCurrency: z.string().nullish(),
  billingEstimatedUnits: z.string().nullish(),
  billingName: z.string().nullish(),
  businessTeam: z.string().nullish(),
  candidateOpportunities: 
    z.array(z.lazy(() => candidateOpportunitySchema))
  .nullish(),
  candidateOpportunitiesStatusHistories: 
    z.array(z.lazy(() => candidatesOpportunitiesStatusHistorySchema))
  .nullish(),
  clientBudgetConfirmed: z.nativeEnum(ClientBudgetConfirmed).nullish(),
  clientBudgetMax: z.number().nullish(),
  clientBudgetMin: z.number().nullish(),
  clientName: z.string().nullish(),
  clientRequests: z.array(z.lazy(() => clientRequestSchema)).nullish(),
  closedDate: z.string().date().nullish(),
  closedLostNotes: z.string().nullish(),
  collaborators: 
    z.array(z.lazy(() => opportunityCollaboratorSchema))
  .nullish(),
  competitorType: z.string().nullish(),
  competitorView: z.string().nullish(),
  confidential: z.boolean(),
  confidentialUpdatedAt: z.string().datetime().nullish(),
  confidentialUpdatedBy: z.string().uuid().nullish(),
  contacts: z.array(z.lazy(() => contactSchema)).nullish(),
  contactsOpportunities: 
    z.array(z.lazy(() => contactsOpportunitySchema))
  .nullish(),
  createdAt: z.string().datetime().nullish(),
  cultureSkills: z.string().nullish(),
  currency: z.string().nullish(),
  deliveryManager: z.lazy(() => userSchema).nullish(),
  deliveryManagerId: z.string().uuid().nullish(),
  description: z.string().nullish(),
  digitalIntakeDetails: z.lazy(() => digitalIntakeDetailSchema).nullish(),
  directEligible: z.boolean(),
  drivingNeed: z.string().nullish(),
  engagementType: z.string().nullish(),
  events: z.array(z.lazy(() => eventSchema)).nullish(),
  excludedFromFeedUpdatedAt: z.string().datetime().nullish(),
  excludedFromFeedUpdatedBy: z.string().uuid().nullish(),
  excludedFromFeedUserOverride: z.boolean().nullish(),
  firstCandidateSelectedOrFurtherAt: z.string().datetime().nullish(),
  firstCandidateSubmittedAt: z.string().datetime().nullish(),
  forecastCategory: z.string().nullish(),
  fulfillmentStatus: z.nativeEnum(FulfillmentStatus).nullish(),
  id: z.string().uuid(),
  inadequateSupplyCategory: z.string().nullish(),
  integrationId: z.string().nullish(),
  isExcludedFromFeed: z.boolean().nullish(),
  isFalseStart: z.boolean().nullish(),
  isInterviewing: z.boolean().nullish(),
  isQualificationComplete: z.boolean().nullish(),
  isRemote: z.boolean().nullish(),
  jobName: z.string().nullish(),
  languages: z.array(z.lazy(() => opportunityLanguageSchema)).nullish(),
  laptopProvider: z.nativeEnum(LaptopProvider).nullish(),
  lastUpdatedBy: z.string().uuid().nullish(),
  locationCityStateCountry: z.string().nullish(),
  madeAvailableToFeedAt: z.string().datetime().nullish(),
  madeAvailableToFeedNotificationAt: z.string().datetime().nullish(),
  matterId: z.string().nullish(),
  newSubmissionType: z.boolean().nullish(),
  nextStep: z.string().nullish(),
  offering: z.string().nullish(),
  onsiteRemote: z.string().nullish(),
  opportunityLostCoveragePlan: z.string().nullish(),
  opportunityOwnerSalesforceId: z.string().nullish(),
  ownerUser: z.lazy(() => userSchema).nullish(),
  ownerUserId: z.string().uuid().nullish(),
  position: z.lazy(() => positionSchema).nullish(),
  positions: z.array(z.lazy(() => positionSchema)).nullish(),
  positionsCount: z.number().int().nullish(),
  primaryFocusArea: z.nativeEnum(FocusArea).nullish(),
  primaryPracticeArea: z.nativeEnum(PracticeAreaEnum).nullish(),
  qualifiedAt: z.string().datetime().nullish(),
  reasonLost: z.string().nullish(),
  region: z.string().nullish(),
  renewal: z.string().nullish(),
  renewalContract: z.string().nullish(),
  requiredNumResources: z.number().int().nullish(),
  requiredTalentCountryCode: z.nativeEnum(CountryCode).nullish(),
  salesCloseDate: z.string().date().nullish(),
  salesLead: z.lazy(() => userSchema).nullish(),
  salesLeadId: z.string().uuid().nullish(),
  salesNote: z.string().nullish(),
  salesforceAccountId: z.string().nullish(),
  salesforceContact: z.lazy(() => contactSchema).nullish(),
  salesforceContactId: z.string().uuid().nullish(),
  salesforceContractId: z.string().nullish(),
  salesforceCxLead: z.lazy(() => userSchema).nullish(),
  salesforceCxLeadId: z.string().uuid().nullish(),
  salesforceId: z.string().nullish(),
  salesforceQuoteId: z.string().nullish(),
  selfService: z.boolean(),
  stage: z.nativeEnum(OpportunityStage).nullish(),
  stageCode: z.nativeEnum(OpportunityStageCode).nullish(),
  startDate: z.string().date().nullish(),
  statusUpdatedAt: z.string().datetime().nullish(),
  stopDirectInterestEmails: z.boolean(),
  submissionId: z.string().uuid().nullish(),
  submissionLastUpdatedAt: z.string().datetime().nullish(),
  submissionPublishedAt: z.string().datetime().nullish(),
  supervisingLawyerContactId: z.string().uuid().nullish(),
  supervisingLawyerCountryCode: z.nativeEnum(CountryCode).nullish(),
  supervisingLawyerState: z.string().nullish(),
  synced: z.boolean(),
  talentInMind: z.nativeEnum(YesNoMaybe).nullish(),
  transactionSubType: 
    z.nativeEnum(OpportunityTransactionSubType)
  .nullish(),
  updatedAt: z.string().datetime().nullish(),
  useCase: z.string().nullish(),
  workLocation: z.nativeEnum(WorkLocation).nullish(),
});

export type Opportunity = z.infer<typeof opportunitySchema>;
